<script lang="ts" setup>
    import { ref } from "vue";
    import SearchBase  from './SearchBase.vue';
    import { ICodeSearchItem, codeSearchDiagnosis } from '../../lib/ChoiceApi';
    import { ISearchBaseInputs } from "../../lib/Models/SearchModel";

    //const emit = defineEmits(["onChange", "update: defaultSearchText"]);
    const emit = defineEmits<{
        (e: "onChange", selectedItem?: ICodeSearchItem): void,
        (e: "update: defaultSearchText", newValue?: string): void
    }>();

    const props = withDefaults(defineProps<{
        // Placeholder text to be displayed inside text control if no values
        placeholder?: string,
        // Label for the component
        label?: string,
        // The default search value 
        defaultSearchText?: string,
        // The maximum height of the search results
        maxHeight?: number,
        // Reset Focus
        resetFocus?: boolean,
        // Perform auto-search on text input
        enableAutoSearch?: boolean,
        // Show the clear search function
        showClearSearch?: boolean
    }>(), {
        placeholder: "Search Code",
        label: "Code"
    });
    
    const searchColumns = ref(
        [
            { title: "Code Id", element: "codeId" },
            { title: "Code", element: "code" },
            { title: "Short Description", element: "codeShortDesc" },
            { title: "Code Type", element: "codeType" },
            { title: "Start Date", element: "codeStartDate" },
            //{ title: "End Date", element: "codeEndDate" }
        ],        
    );
    const searchResults = ref<ICodeSearchItem[]>([]);

    async function performSearch(inputs: ISearchBaseInputs) {
        const respSearch = await codeSearchDiagnosis.search(inputs);
        searchResults.value = respSearch || []; 
    }

    async function performSearchBase(inputs: ISearchBaseInputs)  {
        const searchInputs: ISearchBaseInputs = { 
            searchText: inputs.searchText,
            displayAllResults: false 
        };
        performSearch(searchInputs);
    }

    function onChange(selectedItem: ICodeSearchItem) {
        emit("onChange", (undefined === selectedItem || !selectedItem) ? undefined : selectedItem);
        emit("update: defaultSearchText", (undefined === selectedItem || !selectedItem) ? undefined : selectedItem.codeAndDesc);
    }

</script>

<template>
    <search-base 
        :placeholder="placeholder" 
        :label="label" 
        :columns="searchColumns" 
        :enableAutoSearch="enableAutoSearch"
        :showClearSearch="showClearSearch"
        displayColumn="codeAndDesc"
        :defaultSearchText="defaultSearchText"
        :searchResults="searchResults"
        @performSearchBase="performSearchBase"
        @onChange="onChange">
    </search-base>
</template>